"use client";

import { usePathname } from "next/navigation";
import { Languages } from "lucide-react";
import { useI18n } from "@repo/ui/providers";
import { isWwwPageTranslated } from "@repo/lib";

/**
 * www.th.gl in a non-English locale: every page exists (/de/apps …), but
 * only some are translated (isWwwPageTranslated); the rest shows this note
 * above the English page (Leon 2026-10-13).
 */
export function TranslationNotice() {
  const { t, locale } = useI18n();
  const pathname = usePathname() ?? "/";
  // Prerendered pages report the internal /www/<locale>/… route on the
  // server and /<locale>/… in the browser: strip both prefixes.
  const path =
    pathname
      .replace(/^\/www(?=\/|$)/, "")
      .replace(new RegExp(`^/${locale}(?=/|$)`), "") || "/";
  if (isWwwPageTranslated(path, locale)) return null;
  return (
    <div className="mx-4 md:mx-10 mt-4 flex items-center justify-center gap-2 rounded-md border border-amber-500/40 bg-amber-500/10 px-4 py-2 text-center text-sm text-amber-200">
      <Languages className="h-4 w-4 shrink-0" />
      {t("www.translationNotice")}
    </div>
  );
}
